import { client } from "@/store/client.js";
import axios from "axios";

export const namespaced = true;

export const state = {	
	user: null
};

const setUserData = function(userData) {    
    axios.defaults.headers.common["Authorization"] = `Bearer ${userData.token}`
    client.coreapi.defaults.headers.common["Authorization"] = `Bearer ${userData.paytoken}`
    client.core.defaults.headers.common["Authorization"] = `Bearer ${userData.token}`
}

export const mutations = {
    set_User_Data (state, userData) { 
        
        if( userData.data.company === null) {  
            userData.data.company = {
                'email': null,                    
                'taxnumber': null,                    
                'country': null,                    
                'name': '',
                'contactname': '',
                'lastname': '',
                'firstname': '',
                'tel': '',
                'zip': '',
                'hsnr': '',
                'street': '',
                'city': '',
            }
        }
        if(!userData.core.admin) {
            if(userData.core.granted.length > 3) {
                console.log(userData.core.granted.substring(3,4))
                if(userData.core.granted.substring(3,4) !== 0) {
                    userData.hasbtbright = true
                    //userData.subscribed = false
                }
            }
        }
        state.user = userData
        
        localStorage.setItem('current_user', JSON.stringify(userData))        
        setUserData(userData)
    },

    clearUserData (state) {
        localStorage.removeItem('current_user')
        state.user = null
        //location.reload()
    },
    updatePaymentInfo(state, paymentInfo) {
        paymentInfo.company.lastname = paymentInfo.company.lastname ? paymentInfo.company.lastname : state.user.data.lastname  
        paymentInfo.company.firstname = paymentInfo.company.firstname ? paymentInfo.company.firstname : state.user.data.firstname  
        Object.assign(state.user.data.company, paymentInfo.company)
        Object.assign(state.user.core, paymentInfo)        
    }
}

export const actions = {
    login ({ commit,dispatch }, credentials) {    
        return client.coreapi.post('/login', credentials)
        .then(({ data }) => {
            commit('set_User_Data', data)
            return data
        })/* .catch(err => {
            return err.response
            
        }) */
    },

    logout ({ commit }) {
        commit('clearUserData')
    },

    async checkAuth({commit, dispatch}, userData) {        
        return await client.coreapi.post('/checkauth', userData)
        .then(r  => {
            console.log(r)
                          
            commit('set_User_Data', r.data)            
            return r.data
        }).catch(err => {
            console.log(err)
            if (err.response.status === 401) {
                dispatch('logout')
            } 
            return err.response
            
        })
    },
    
    getPaymentInfo({commit}, payment) {        
        console.log(payment)
        return client.coreapi.post('/getcorepaymentinfo', payment)
        .then(( r ) => {
            commit('updatePaymentInfo', r.data)          
            return r.data.company
        })
    },
    async getMyCompany({commit}, payment) {    
        return await client.coreapi.get('/getmycompany')
        .then(r => {    
            return r.data
        })
    },
}

export const getters = {    
    isLogged: state => !!state.user,
    userData: state => state.user 
    /* userData(state) {
        return state.user
    } */
}